import React from 'react';
import { motion } from 'framer-motion';
import { Star, UserIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Comía poco y aun así seguía inflamada. En dos semanas entendí qué me estaba afectando y la pesadez después de comer desapareció. Ahora tengo más energía durante el día.',
  name: 'Laura M., 46 años — Ciudad de México 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/61Dw8bEFUymhMcxcWxCUFz/imglaura.png'
}, {
  quote: 'Pensé que era la edad, pero eran mis hábitos. Con pequeños cambios bajé la inflamación y duermo mejor. Me siento más estable y ligera.',
  name: 'Carmen R., 52 años — Guadalajara 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/aYWRR8vDQSwQtWep1W5hVL/imgcarmen.png'
}, {
  quote: 'No quería otra dieta más. Ajusté mis desayunos y dejé de inflamarme cada tarde. Por fin siento que mi cuerpo responde.',
  name: 'Ana P., 41 años — Monterrey 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/dq4DnhgM1sQy9W3mfvuweT/imgana.png'
}, {
  quote: 'Vivía cansada y con el abdomen pesado. Después de tres semanas noté menos inflamación y más energía. No es milagro, son cambios reales.',
  name: 'María L., 49 años — CDMX 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/9EC8cHmce4rjk8BEmn6LsC/Maria.png'
}];
export function TestimonialsSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-247">
      <div className="max-w-6xl mx-auto" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-249">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive mb-4" data-id="element-250">
            Mujeres que eligieron cuidarse
          </h2>
          <p className="text-lg md:text-xl text-warm-gray" data-id="element-251">
            Ellas encontraron armonía, energía y ligereza. Tú también puedes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-252">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-card flex flex-col justify-between" data-id="element-253">
              <div data-id="element-254">
                <div className="flex gap-1 mb-6" data-id="element-255">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-warm-accent text-warm-accent" data-id="element-256" />)}
                </div>
                <p className="text-warm-gray text-lg italic mb-8 leading-relaxed" data-id="element-257">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Profile row with circular image placeholder */}
              <div className="flex items-center gap-3" data-id="element-258">
                <div className="w-12 h-12 rounded-full bg-sage/15 border-2 border-sage/30 flex-shrink-0 overflow-hidden flex items-center justify-center" data-id="element-259">
                  {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-260" /> : <UserIcon className="w-6 h-6 text-sage/50" data-id="element-261" />}
                </div>
                <p className="text-olive font-bold font-heading" data-id="element-262">
                  {testimonial.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}